<template>
  <div>
<!--    <div>-->
<!--      <el-button type="primary" @click="electron">校验电子培训卷</el-button>-->
<!--      <el-button type="warning" @click="subsidy">补贴信息查询</el-button>-->
<!--      <el-button type="danger" @click="archives">学员电子档案查询</el-button>-->
<!--    </div>-->
    <div v-if="subsidyList.length > 0">
      <el-card class="box-card" v-for="(item, key) in subsidyList" :key="key">
        <div class="flex-between">
          <div>
            <div>姓名：{{item.aac003}}</div>
            <div>等级：{{item.aca11a}}</div>
            <div>补贴标准：{{item.yjn051}}</div>
          </div>
          <div>
            <div>身份证号：{{item.aac002}}</div>
            <div>课程名称：{{item.aca112}}</div>
            <div>补贴金额：{{item.yjn052}}</div>
          </div>
          <div>
            <div>性别：{{item.aac004}}</div>
            <div>已学时长：{{item.yxsc}}</div>
          </div>
          <div>
            <div>出生日期：{{item.aac006}}</div>
          </div>
        </div>
        <div class="flex-between">
          <div><div>审核状态：{{item.yae421}}</div></div>
          <div><div>审核意见：{{item.yae422}}</div></div>
        </div>
        <div class="flex-between">
          <div>审核人姓名：{{item.yae411}}</div>
          <div>审核机构：{{item.yae413}}</div>
          <div>审核时间：{{item.yae414}}</div>
        </div>
        <div>批次号：{{item.lsh}}</div>

      </el-card>
    </div>
    <div v-else class="noList">
      暂无补贴信息
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
export default {
  name: "studentInformation",
  computed: {
    ...mapState(['studentInf'])
  },
  data() {
    return{
      subsidyList: []
    }
  },
  mounted() {
    this.subsidy()
  },
  methods: {
    electron() {
      this.$http({
        method: 'post',
        url: '/api/renren-fast/app/zxpxjp/zxpx_02',
        data: {
          'coupon': {
            "aca111": this.studentInf[0].aca111,       // 课程编号
            "aca112": this.studentInf[0].aca112,      // 课程名称
            "aca11a": this.studentInf[0].aca11a,      // 等级
            "couponcode": this.studentInf[0].couponcode,   // 身份证号
            "couponname": this.studentInf[0].couponname    // 姓名
          }
        }
      }).then((result) => {
        console.log(result)
      })
    },
    subsidy() {
      console.log(this.studentInf[0])
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/zxpxjp/zxpx_15',
        params: {
          ahb001: this.studentInf[0] ? this.studentInf[0].ahb001 : '',  // 机构编码
          ahb004: this.studentInf[0] ? this.studentInf[0].ahb004 : ''  // 机构名称
        }
      }).then((result) => {
        console.log(result)
        this.subsidyList = result.data.data
      })
    },
    archives() {
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/zxpxjp/zxpx_16',
      }).then((result) => {
        console.log(result)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.flex-between{
  display: flex;
  justify-content: space-between;
}
  .noList{
    width: 100%;
    text-align: center;
    margin-top: 50px;
    font-size: 18px;
    color: #999999;
  }
  .box-card{
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/studentInformation.vue